<template lang="pug">
    div
        Button(type="primary" icon="md-add" style="margin-bottom: 10px;" @click="edit") {{ $t("rcmtable.editText")}}
        Table(:columns="columns" :data="value" :no-data-text="$t('rcmtable.noDataText')")
        Modal(v-model="isEditing" :title="$t('domainsetting.customVariables')" :mask-closable="false")
            template(v-if="form.data.length>0")
                Row(:gutter="16" style="margin-bottom: 20px;")
                    Col(span=9)
                        label {{ $t("domainsetting.customVariablesKey") }}
                    Col(span=8)
                        label {{ $t("domainsetting.customVariablesValue") }}
                Form(ref="formRef" :model="form" :rules="formRules")
                    Row(:gutter="16" v-for="(item, index) in form.data" :key="index" style="margin-bottom: 20px;")
                        Col(span=8)
                            FormItem(:prop="'data.' + index + '.key'")
                                Input(v-model="item.key")
                        Col(span=1 style="padding-top: 6px;")
                            span :
                        Col(span=8)
                            FormItem(:prop="'data.' + index + '.value'")
                                Input(v-model="item.value")
                        Col
                            Button(shape="circle" icon="md-trash" @click="remove(index)")
            Button(type="primary" @click="add") {{$t("rcmtable.createText")}}
            div(slot="footer")
                Button(@click="cancel") {{$t('rcmtable.cancelText')}}
                Button(@click="confirm") {{$t('rcmtable.confirmText')}}
</template>
<script>
import enumList from "@/libs/enumList";

export default {
    name: "CustomVariables",
    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            columns: [
                {
                    title: this.$t("domainsetting.customVariablesKey"),
                    key: "key",
                },
                {
                    title: this.$t("domainsetting.customVariablesValue"),
                    key: "value",
                },
            ],
            form: { data: [] },
            isEditing: false,
        };
    },
    methods: {
        edit() {
            this.form.data = this.value.map((item) => ({ ...item }));
            this.isEditing = true;
        },
        remove(index) {
            this.form.data.splice(index, 1);
        },
        add() {
            if (this.form.data.length >= 3) {
                return this.$Message.warning(this.$t("rcmtable.exceedMaxItemsError", { limit: 3 }));
            }
            this.form.data.push({
                key: "",
                value: "",
            });
        },
        cancel() {
            this.isEditing = false;
        },
        confirm() {
            if (this.form.data.length === 0) {
                this.$emit("input", this.form.data);
                this.isEditing = false;
                return;
            }

            this.$refs.formRef.validate((valid) => {
                if (!valid) return;

                // 檢查有無重複的 key (不區分大小寫)
                const keys = this.form.data.map(({ key }) => key.toLowerCase());
                const hasDuplicate = keys.length !== new Set(keys).size;
                if (hasDuplicate) {
                    this.$Message.error(this.$t("rcmtable.duplicateKeyError"));
                    return;
                }

                this.$emit("input", this.form.data);
                this.isEditing = false;
            });
        },
    },
    computed: {
        formRules() {
            const rules = {};
            this.form.data.forEach((_, index) => {
                rules[`data.${index}.key`] = [
                    {
                        validator: (rule, value, callback) => {
                            // 空值
                            if (!value) {
                                return callback(new Error(this.$t("rcmtable.validateEmptyText")));
                            }
                            // 正則
                            if (!/^[a-zA-Z0-9\-_]+$/.test(value)) {
                                return callback(
                                    new Error(`${this.$t("rcmtable.validateIllegalCharsPrefix")}: a-z 0-9 - _`)
                                );
                            }
                            // proxySetHeader 的系統選項 || wafSetReqHeaders 禁止的 key
                            const { PROXY_SET_HEADER_SYSTEM_OPTIONS, WAF_SET_REQ_HEADERS_PROHIBITED_KEYS } = enumList;
                            const valueLower = value.toLowerCase();
                            const proxySetHeaderSystemOptionsLower = PROXY_SET_HEADER_SYSTEM_OPTIONS.map((v) =>
                                v.toLowerCase()
                            );
                            const wafSetReqHeadersProhibitedKeysLower = WAF_SET_REQ_HEADERS_PROHIBITED_KEYS.map((v) =>
                                v.toLowerCase()
                            );
                            if (
                                proxySetHeaderSystemOptionsLower.includes(valueLower) ||
                                wafSetReqHeadersProhibitedKeysLower.includes(valueLower)
                            )
                                return callback(new Error(this.$t("rcmtable.systemReservedKeyError")));
                            // 長度
                            const maxLength = 256;
                            if (value.length > maxLength) {
                                return callback(
                                    new Error(`${this.$t("rcmtable.validateExceedLengthPrefix")}: ${maxLength}`)
                                );
                            }
                            callback();
                        },
                        trigger: "blur",
                    },
                ];
                rules[`data.${index}.value`] = [
                    {
                        validator: (rule, value, callback) => {
                            // 空值
                            if (!value) {
                                return callback(new Error(this.$t("rcmtable.validateEmptyText")));
                            }
                            // 正則（允許空格）
                            if (!/^[a-zA-Z0-9\-_ ]+$/.test(value)) {
                                return callback(
                                    new Error(`${this.$t("rcmtable.validateIllegalCharsPrefix")}: a-z 0-9 - _`)
                                );
                            }
                            // 長度
                            const maxLength = 256;
                            if (value.length > maxLength) {
                                return callback(
                                    new Error(`${this.$t("rcmtable.validateExceedLengthPrefix")}: ${maxLength}`)
                                );
                            }
                            callback();
                        },
                        trigger: "blur",
                    },
                ];
            });
            return rules;
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/FormItems/CustomVariables.vue